import { render, staticRenderFns } from "./OrganizationIndividualSpecialist.vue?vue&type=template&id=5bcf117f&scoped=true&"
import script from "./OrganizationIndividualSpecialist.vue?vue&type=script&lang=js&"
export * from "./OrganizationIndividualSpecialist.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationIndividualSpecialist.vue?vue&type=style&index=0&id=5bcf117f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf117f",
  null
  
)

export default component.exports